function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Curators.css';
import React, { useEffect, useState } from 'react';
import { get, getDictionaryItem, injectImageResolution, pathJoin, getMediaHost, isChina, getListingItemURL, generatrURLFromTags, getGlobalDictionaryTerm, getColorByTheme, canUseDOM, getPageThemeColors, getTags } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as FbIcon } from '../../resources/icons/footer-fb-icon.svg';
import { ReactComponent as TwitterXIcon } from '../../resources/icons/x-logo-white-v2.svg';
import { ReactComponent as TiktokIcon } from '../../resources/icons/logo-tiktok.svg';
import { ReactComponent as LinkedinIcon } from '../../resources/icons/ic-linkedin.svg';
import { ReactComponent as YoutubeIcon } from '../../resources/icons/footer-yt-icon.svg';
import { ReactComponent as InstagramIcon } from '../../resources/icons/icon-instagram.svg';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink/RouterLink';
import getListing, { loadCategoryAlgoliaResults } from '../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData, tealiumMergeClickNewData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';

//pesonlization
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { useIsVisible } from '../../utils/useIsVisible';
import { convertToAnalyticObject } from '../../utils/analytics';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import clsx from 'clsx';
import Loader from '../atoms/Loader/Loader';
import { ReactComponent as IconPauseItem } from '../../resources/icons/IconPauseFat.svg';
import { ReactComponent as IconPlay } from '../../resources/icons/IconPlay2.svg';
import throttle from 'lodash/throttle';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
export const CuratorBlock = _ref => {
  let {
    item,
    hostLink = '',
    analytics = {},
    seeMore = {},
    parentParams,
    selectedPrimaryColor,
    setModalVideoState,
    toggle,
    isMultipleSocialMedia = false
  } = _ref;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), item.image])}`, 335, 255);
  const [china, setIsChina] = React.useState(false);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const korean = get(sitecoreContext, 'language') === 'ko';
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const BackgroundColorHex = get(parentParams, 'BackgroundColorHex');
  const activeColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
  useEffect(() => {
    setIsChina(isChina());
  });
  const ctaLabel = get(item, 'ctaLabel');
  const videoSrc = get(item, 'mediaUrl');
  const {
    eventsAnalytics,
    params
  } = analytics;
  const editable = get(item, 'editable');
  const tags = get(item, 'tags');
  const curator_country = get(item, 'curator_country');
  const featured = get(item, 'featured');
  const isverification = get(item, 'isverification');
  const visibletags = get(item, 'visibletags', []);
  const sendSocialMediaAnalytic = socialMediaName => {
    const analyticStr = `${item.englishTitle} : ${socialMediaName}`;
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['socialAnalytics'], params), analyticStr);
  };
  const title = {
    value: get(item, 'title')
  };
  const curatorRole = {
    value: get(item, 'curatorRole')
  };
  const introText = {
    value: get(item, 'introText')
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "curator curator--item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "category-labels-wrapper"
  }, item.curator_category_label_title ? /*#__PURE__*/React.createElement("div", {
    className: "category-labels-box",
    style: {
      '--color-hex': item.curator_category_label_color
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: `category-label-item`,
    style: {
      position: 'absolute',
      color: '#fff',
      backgroundColor: '#fff',
      height: '100%',
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: `category-label-item ${item.curator_category_label_visualization}`
  }, item.curator_category_label_title)) : /*#__PURE__*/React.createElement(React.Fragment, null)), videoSrc && /*#__PURE__*/React.createElement("div", {
    className: "rs_skip video-control-btn my-icon-white"
  }, /*#__PURE__*/React.createElement(IconPlay, {
    width: 12,
    height: 14
  })), item.image && /*#__PURE__*/React.createElement(React.Fragment, null, item.url ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    title: item.englishTitle,
    "aria-label": item.englishTitle,
    "aria-labelledby": item.englishTitle,
    linksTarget: videoSrc ? 'internal' : void 0,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: e => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), item.englishTitle);
      if (videoSrc) {
        setModalVideoState(mVideoSt => _objectSpread(_objectSpread({}, mVideoSt), {}, {
          type: videoSrc.startsWith('http') ? 'external' : 'media',
          src: videoSrc.startsWith('http') ? videoSrc : BASE_URL + videoSrc,
          title: 'hasTitle'
        }));
        toggle();
        e.preventDefault();
      }
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "curator__image",
    src: imgSrc,
    alt: "Curator Image",
    "aria-hidden": "true"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "curator__image",
    src: imgSrc,
    alt: "Curator Image",
    "aria-hidden": "true"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "curator__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-group-header"
  }, title ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary",
    title: item.title,
    "aria-label": item.title,
    "aria-labelledby": item.title,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), item.englishTitle)
  }, ' ', /*#__PURE__*/React.createElement(Text, {
    editable: editable,
    className: "curator__name",
    tag: "h4",
    field: title
  })) : null, isverification ? /*#__PURE__*/React.createElement("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60288 1.79876C7.42705 0.850931 8.64332 0.25 10 0.25C11.3566 0.25 12.5728 0.850872 13.397 1.79861C14.6501 1.71106 15.9352 2.14616 16.8946 3.10557C17.854 4.06498 18.2891 5.35009 18.2016 6.60319C19.1492 7.42735 19.75 8.64348 19.75 10C19.75 11.3568 19.149 12.5731 18.2011 13.3973C18.2884 14.6502 17.8533 15.935 16.8941 16.8943C15.9348 17.8535 14.65 18.2886 13.3971 18.2013C12.5729 19.1491 11.3567 19.75 10 19.75C8.6434 19.75 7.4272 19.1491 6.60304 18.2014C5.34992 18.289 4.0648 17.8539 3.10537 16.8945C2.14596 15.935 1.71086 14.6499 1.79841 13.3968C0.850785 12.5726 0.25 11.3565 0.25 10C0.25 8.64342 0.850846 7.42723 1.79855 6.60306C1.7111 5.35005 2.14621 4.06507 3.10554 3.10574C4.06488 2.1464 5.34987 1.71129 6.60288 1.79876ZM13.6103 8.18593C13.8511 7.84887 13.773 7.38046 13.4359 7.1397C13.0989 6.89894 12.6305 6.97701 12.3897 7.31407L9.1543 11.8436L7.53033 10.2197C7.23744 9.92678 6.76256 9.92678 6.46967 10.2197C6.17678 10.5126 6.17678 10.9874 6.46967 11.2803L8.71967 13.5303C8.87556 13.6862 9.09215 13.7656 9.31186 13.7474C9.53157 13.7293 9.73216 13.6153 9.8603 13.4359L13.6103 8.18593Z",
    fill: item.curator_iconandtag_color || 'var(--m10-curators-background-color, var(--main-color))'
  })) : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement("div", {
    className: "tags-box"
  }, curator_country ? /*#__PURE__*/React.createElement("span", {
    className: "uppercase curator-country"
  }, curator_country) : /*#__PURE__*/React.createElement(React.Fragment, null), visibletags.length && curator_country ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "2",
    fill: "#505050"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null), visibletags.map((tag, index) => /*#__PURE__*/React.createElement(React.Fragment, null, index ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "2",
    fill: "#505050"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
    className: "uppercase curator-celebrity",
    style: {
      color: item.curator_iconandtag_color || 'var(--m10-curators-background-color, var(--main-color))'
    }
  }, tag)))), /*#__PURE__*/React.createElement(Text, {
    editable: editable,
    className: "curator__info",
    tag: "p",
    field: introText
  }), /*#__PURE__*/React.createElement("div", {
    className: isMultipleSocialMedia ? 'multiple-social-media' : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-group-footer"
  }, item.url && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary CTAsList-links_btn",
    title: item.title,
    "aria-label": item.title,
    "aria-labelledby": item.title,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaClickAnalytics'], params), item.ctaLabel ? item.ctaLabel : item.englishTitle)
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, ctaLabel || seeMore)), !china && !isMultipleSocialMedia && getSosialMedias(item, sendSocialMediaAnalytic).shift()), isMultipleSocialMedia ? /*#__PURE__*/React.createElement("div", {
    className: "button-group-footer-social-media"
  }, getSosialMedias(item, sendSocialMediaAnalytic)) : /*#__PURE__*/React.createElement(React.Fragment, null))));
};
const getSosialMedias = (item, analyticFunc) => {
  const smList = [];
  if ('instagram' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Instagram'),
      href: get(item, 'instagram')
    }, /*#__PURE__*/React.createElement(InstagramIcon, null)));
  }
  if ('tiktok' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Tiktok'),
      href: get(item, 'tiktok')
    }, /*#__PURE__*/React.createElement(TiktokIcon, null)));
  }
  if ('facebook' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Facebook'),
      href: get(item, 'facebook')
    }, /*#__PURE__*/React.createElement(FbIcon, null)));
  }
  if ('twitter' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Twitter'),
      href: get(item, 'twitter')
    }, /*#__PURE__*/React.createElement(TwitterXIcon, null)));
  }
  if ('youtube' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Youtube'),
      href: get(item, 'youtube')
    }, /*#__PURE__*/React.createElement(YoutubeIcon, null)));
  }
  if ('linkedin' in item) {
    smList.push(/*#__PURE__*/React.createElement("a", {
      className: "c-media__link",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => analyticFunc('Linkedin'),
      href: get(item, 'linkedin')
    }, /*#__PURE__*/React.createElement(LinkedinIcon, null)));
  }
  return smList.slice(0, 4);
};
export const emptyModalVideo = {
  src: '',
  type: '',
  title: '',
  playing: false,
  loading: true,
  visiblePlayButton: true
};

// List of social media fields to check
const socialMediaFields = ["instagram", "youtube", "facebook", "twitter", "tiktok", "linkedin"];

// Function to check if an object has at least two social media fields
export function hasAtLeastTwoSocialMedia(obj) {
  // Count how many social media fields exist in the object
  const count = socialMediaFields.filter(field => field in obj).length;
  return count >= 2;
}
export const Curators = _ref2 => {
  let {
    fields,
    params,
    route
  } = _ref2;
  const [searchResults, setSearchResults] = React.useState([]);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const isPersonalised = get(sitecoreContext, 'isPersonalised');
  const modalVideo = React.useRef(null);
  const [modalVideoState, setModalVideoState] = useState(emptyModalVideo);
  const {
    isShown,
    toggle
  } = useModal();
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const overviewButton = get(fields, 'data.overviewButton');
  const hasOverviewButtonTitle = get(overviewButton, 'title.jss.value');
  const overviewButtonTitle = get(overviewButton, 'title.jss');
  const useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  const considerPageLevelTags = Boolean(get(fields, 'data.item.considerPageLevelTags.jss.value'));
  const listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.url');
  const overviewButtonUrl = useCustomListingPage ? listingPageLink : get(overviewButton, 'link.jss.value.href');
  const categoryLabels = get(fields, 'data.settingsCuratorCategoryLabels.categoryLabels');
  const hasCuratorTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const curatorTitle = get(fields, 'data.item.title.jss');
  const SearchCount = get(params, 'SearchCount');
  const dictionary = get(fields, 'data.dictionary');
  //socail icons from Profile Cards
  const seeMore = getDictionaryItem(dictionary, 'SeeMore') || 'See More';
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const itemTags = get(fields, 'data.item.tags.targetItems') || [];
  let tags = get(fields, 'data.item.tags.targetItems') || [];
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const tagsList = considerPageLevelTags ? [...contextItemTags, ...itemTags] : itemTags;
  const [isVdsite, setIsVdsite] = React.useState(true);
  const ref = React.useRef();
  const isVisible = useIsVisible(ref);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  tags = tagsList.map(item => {
    const tag = get(item, 'title.jss.value') || get(item, 'name');
    if (tag) {
      return 'tags:' + tag;
    } else {
      return '';
    }
  });
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const styleThemeHexColor = BackgroundColorHex ? {
    '--m10-curators-background-color': BackgroundColorHex,
    '--m10-curators-background-active-color': ActiveColorHex,
    '--m10-curators-color': ColorHex
  } : {
    '--m10-curators-background-color': selectedPrimaryColor,
    '--m10-curators-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m10-curators-color': getColorByTheme(selectedPrimaryColor)
  };
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(() => {
    if (modalVideoState.type === 'media') {
      let timer;
      if (modalVideoState.visiblePlayButton) {
        timer = setTimeout(() => {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            visiblePlayButton: false
          }));
        }, 2000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [modalVideoState]);
  React.useEffect(() => {
    if (isShown) {
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        visiblePlayButton: true
      }));
    }
  }, [isShown]);
  const indexName = get(params, 'SearchIndex');
  const intents = get(fields, 'data.item.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  const conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  const allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(condition => {
    const {
      handler,
      mappings
    } = condition;
    const conditionValues = handler.getValues({
      mappings,
      sitecoreContext
    });
    if (conditionValues) {
      allValues.push(...conditionValues);
    }
  });
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: searchResults,
    conditions: [algoliaScoredCondition(allValues)]
  });
  useEffect(() => {
    if (isVisible) {
      setSeeMoreURLTags(generatrURLFromTags(tagsList));
      if (isPersonalised && intentsLength) {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, 'type:Curator', SearchCount, [...tags], [], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
          setSearchResults(hits);
          refreshTracking();
        })();
      } else {
        let itemFilter = {
          hitsPerPage: SearchCount,
          facetFilters: [['type:Curator'], [...tags]],
          filters: currentPageID ? `NOT objectID:${currentPageID}` : ''
        };
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          setSearchResults(hits && hits.hits);
        });
      }
    }
  }, [currentPageID, isPersonalised, isVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!fields) {
    console.info('Curator component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Curator component is empty: please provide data source]");
    }
    return null;
  }
  const renderTileItems = hostLink => {
    let itemsToMap = searchResults;
    if (intentsLength && isPersonalised) {
      itemsToMap = personalizedList;
    }
    const isMultipleSocialMedia = itemsToMap.some(hasAtLeastTwoSocialMedia);
    return itemsToMap.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp adjust-height",
      animateOnce: true,
      duration: 1 + index / 3
    }, /*#__PURE__*/React.createElement(CuratorBlock, {
      item: item && item.item ? item.item : item,
      categoryLabels: categoryLabels,
      seeMore: seeMore,
      analytics: {
        eventsAnalytics,
        params
      },
      modalVideoState: modalVideoState,
      isMultipleSocialMedia: isMultipleSocialMedia,
      setModalVideoState: setModalVideoState,
      toggle: toggle,
      hostLink: hostLink,
      selectedPrimaryColor: selectedPrimaryColor,
      parentParams: params
    })));
  };
  const validateItems = intentsLength && isPersonalised ? personalizedList : searchResults;
  const modalPlayButtonHandler = () => {
    if (modalVideo.current) {
      if (modalVideoState.playing) {
        modalVideo.current.pause();
      } else {
        modalVideo.current.play();
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        playing: !modalVideoState.playing
      }));
    }
  };
  let checkMouseMoved;
  if (canUseDOM) {
    checkMouseMoved = throttle(() => {
      if (!modalVideoState.visiblePlayButton) {
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          visiblePlayButton: true
        }));
      }
    }, 300);
  }
  const renderVideo = styles => {
    if (!modalVideoState.src || !modalVideoState.type) {
      return null;
    }
    if (modalVideoState.type === 'external') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          toggle();
          setModalVideoState(emptyModalVideo);
        },
        className: clsx(styles, 'modal-yt-iframe-container')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-yt-iframe-ar-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        width: "560",
        height: "315",
        src: modalVideoState.src,
        title: modalVideoState.title,
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "modal-yt-iframe"
      })));
    }
    if (modalVideoState.type === 'media') {
      return /*#__PURE__*/React.createElement("div", {
        onMouseMove: checkMouseMoved,
        className: clsx(styles, {
          'hidden-play-button': !modalVideoState.visiblePlayButton
        })
      }, /*#__PURE__*/React.createElement("video", {
        ref: modalVideo,
        className: clsx('modal-video', {
          'modal-video--load-over': !modalVideoState.loading
        }),
        playsInline: true,
        loop: true,
        onProgress: () => {
          if (modalVideoState.loading) {
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              loading: false
            }));
          }
        },
        muted: false,
        preload: "auto",
        autoPlay: false
      }, /*#__PURE__*/React.createElement("source", {
        src: modalVideoState.src,
        type: "video/mp4"
      }), /*#__PURE__*/React.createElement("track", {
        kind: "captions"
      })), modalVideoState.loading ? /*#__PURE__*/React.createElement(Loader, {
        color: "#000000"
      }) : /*#__PURE__*/React.createElement("button", {
        className: clsx('btn--reset modal-play-button', {
          'modal-play-button--playing': modalVideoState.playing
        }),
        onClick: modalPlayButtonHandler
      }, modalVideoState.playing ? /*#__PURE__*/React.createElement(IconPauseItem, null) : /*#__PURE__*/React.createElement(IconPlay, null)));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `curator curator--multiple m10-curators`,
    style: styleThemeHexColor,
    ref: ref
  }, validateItems && validateItems.length > 0 && /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref3;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-12 h-title-x"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      offset: 100,
      delay: 0
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h4",
      className: "curator__title",
      field: curatorTitle
    })), /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params)))))), renderCarousel(renderTileItems(overviewButtonUrl), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 4
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1100
          },
          items: 3
        },
        tablet_landscape: {
          breakpoint: {
            max: 1100,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }, () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params))), /*#__PURE__*/React.createElement("div", {
      className: "article-dots-wrapper"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "article-dots-wrapper__fadeInUp",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      delay: 200
    }, /*#__PURE__*/React.createElement("div", {
      className: "curator__link"
    }, overviewButtonTitle.value && /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      className: "btn btn-secondary btn-mob",
      href: overviewButtonUrl + seeMoreURLTags,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params)),
      title: `${overviewButtonTitle.value}`
    }, overviewButtonTitle.value))), renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params)))));
  })), /*#__PURE__*/React.createElement(Modal, {
    showMobileClose: true,
    fullPageCover: true,
    fullPageVideo: true,
    isShown: isShown,
    hide: () => {
      toggle();
    }
  }, actualSSR ? null : renderVideo(videplayerStyles)));
};
export const videplayerStyles = "v1s9hply";
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref4;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export const commonStyles = "c13n7n00";
export const ltrStyles = "l13b4s7f";
export const rtlStyles = "r1v9h1fg";
export default Curators;